import { useContext } from "react";
import { ShowInfoModalContext } from "../../context/showInfoModal";

export default function Team() {

  const { setInfo, setOpenModal } = useContext(ShowInfoModalContext);

  const teams = [
    { name: "Luis Muñoz", img: 'img/4.webp', width: 1052, height: 1600, description: "Cofundador de Afrodita Models y profesional en Negocios Internacionales, es la mente detrás de la gestión financiera y contable del estudio. Además de asegurar la solidez financiera de Afrodita Models, Luis también es responsable de la gestión del talento humano, incluyendo la contratación y el bienestar del personal. Su enfoque integral y estratégico garantiza un entorno laboral óptimo, donde cada miembro del equipo puede desarrollarse y contribuir al crecimiento continuo del estudio." },
    { name: "Santiago Perdomo", img: 'img/5.webp', width: 1017, height: 1600, description: "Licenciado en Educación Física y cofundador de Afrodita Models, es el motor detrás de la dirección estratégica y operativa del estudio. Como director general, Santiago no solo supervisa las actividades diarias, sino que también impulsa la expansión y el desarrollo de nuevas oportunidades de negocio. Con un enfoque en la creación de estrategias comerciales y de crecimiento, asegura que cada operación esté alineada con los objetivos de Afrodita Models, garantizando así el éxito y la evolución constante del estudio." }
  ]

  const openModal = (index) => {
    setInfo(teams[index]);
    setOpenModal(true);
  }

  return (
    <section id="team">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-md-12">
            <h2 className="section-title">Nuestro Equipo</h2>
            <div className="section-title-divider"></div>
            <p className="section-description text-center wow fadeInUp" data-wow-delay="0.2s">
              En <b>Afrodita Models</b>, la excelencia es nuestra norma. Contamos con un equipo multidisciplinario experto en marketing, tecnología y gestión de talento, dedicado <b>24/7</b> a potenciar tu carrera. Creamos un entorno seguro, profesional y estratégico para que tú solo te preocupes por brillar y <b>monetizar tu contenido</b> al máximo nivel.
            </p>
          </div>
        </div>

        <div className="row justify-content-center wow fadeInUp" data-wow-delay="0.4s">
          {teams.map((member, index) => (
            <div className="col-md-4 col-sm-6 d-flex align-items-stretch mb-4" key={index}>
              <div
                className="member cursor-pointer w-100"
                role="button"
                tabIndex={0}
                onClick={() => openModal(index)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openModal(index);
                  }
                }}
              >
                <div className="pic">
                  <img
                    src={member.img}
                    alt={`${member.name}, cofundador de Afrodita Models`}
                    width={member.width}
                    height={member.height}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <h4>{member.name}</h4>
                <span>Fundador</span>
                {/* Optional: Add social links or short desc if needed, but per original code only pic/name/role were shown in card */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
